import { Utils } from "@/plugins/utils";
import router from '@/router';

export default {
	namespaced: true,
	state: {
		lstIn0: [],
		in0: null,
		selectedIn0: null,
		insert: false,
		update: false,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		lstIna: [],
	},
	getters: {
		in0model(state){
			const in0 = { ...state.in0 }; 

			const lstInaCopy = state.lstIna ? [...state.lstIna] : [];
			in0.lstIna = lstInaCopy;
			
			for (const ina of in0.lstIna) {
				ina.inalista   = in0.in0lista
				ina.inacliente = in0.in0cliente
				ina.inaenderid = in0.in0enderid
				ina.inarecibo  = in0.in0recibo
				ina.inabloccom = in0.in0bloccom			
			}

			return in0
		}
	},
	mutations: {
		set(state, in0){
			state.in0 = in0
			if (in0){
				state.update = true
				state.lstIna = in0.lstIna
			}
		},
		initForm(state){
			state.insert = false
			state.update = false
			state.in0 = null
			state.lstIna = []
		},
		setParamsDataTable(state, payload){
			state.lstIn0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, {in0lista, in0cliente, in0enderid }){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/SpecialPriceByAdress/Find/${in0lista}/${in0cliente}/${in0enderid}`)
			.then(response => {
				let in0 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", in0)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},

		save(store){
			if (store.state.update){
				store.dispatch("update")
				return
			}
			store.dispatch("insert")
		},

		async update(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})

			await this._vm.$axios.put(
				`/Price/SpecialPriceByAdress/Update`,
				store.getters.in0model
			)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-venda")
				store.state.in0 = null
				store.state.lstIna = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
				titleText: "Erro",
				titleColor: "red",
				text: error.message
				}, { root: true })
				return false
			})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
				
		async insert(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Salvando", indeterminate: true }, {root: true})

			const isUpdate = store.state.update

			await this._vm.$axios.post(
				`/Price/SpecialPriceByAdress/Insert`,
				store.getters.in0model
			)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-venda")
				store.state.in0 = null
				store.state.lstIna = []
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
				titleText: "Erro",
				titleColor: "red",
				text: error.message,
				confirmBtn: error.message.includes('Preço especial já cadastrado para o cliente'),
				confirmText: "Redirecionar",
				confirmAction: async () => {
					router.push(
						`/oryxpdv/preco-especial-venda/
						${store.state.in0.in0lista}/
						${store.state.in0.in0cliente}/
						${store.state.in0.in0enderid ?? ''}`
					).then(() => {
						window.location.reload();
					})
				},
				}, { root: true })
				return false
			})

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async delete(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, {root: true})
			await this._vm.$axios.delete(`/Price/SpecialPriceByAdress/Delete/${store.state.in0.in0lista}/${store.state.in0.in0cliente}/${store.state.in0.in0enderid}`)
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/precos-especiais-venda")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async search(store, { limit = 20, page = 1}){
			store.state.loading = true
			store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Price/SpecialPriceByAdress/Search?search=${store.state.search}&limit=${limit}&page=${page}`)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstIn0 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
	}
}